import React, { useEffect, useState } from "react";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  AccumulationLegend,
  PieSeries,
  AccumulationDataLabel,
  AccumulationTooltip,
} from "@syncfusion/ej2-react-charts";

const SkillPopularityChart = ({ chartsData }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (chartsData?.most_used_skills?.length > 0) {
      if (chartsData?.most_used_skills.length > 5)
        setData(
          chartsData?.most_used_skills
            .sort((a, b) => b.count - a.count)
            .slice(0, 5)
        );
      else {
        setData(chartsData?.most_used_skills);
      }
    } else {
      setData([]);
    }
  }, [chartsData]);

  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        maxWidth: "600px",
        margin: "auto",
      }}
    >
      <h3 className="chart-title">Most Popular Skills by User Count</h3>

      {data.length === 0 ? (
        <div className="container-no-records">No Records Found</div>
      ) : (
        <AccumulationChartComponent
          id="donut-skill-chart"
          tooltip={{ enable: true, format: "${point.x} : ${point.y} Users" }}
          legendSettings={{ visible: true, position: "Bottom" }}
        >
          <Inject
            services={[
              AccumulationLegend,
              PieSeries,
              AccumulationDataLabel,
              AccumulationTooltip,
            ]}
          />

          <AccumulationSeriesCollectionDirective>
            <AccumulationSeriesDirective
              dataSource={data}
              xName="SkillName"
              yName="count"
              type="Pie"
              innerRadius="60%" // donut shape
              radius="70%"
              startAngle={0}
              endAngle={360}
              explode={true}
              explodeOffset="10%"
              dataLabel={{
                visible: true,
                position: "Inside",
                name: "SkillName",
                font: { fontWeight: "600", color: "#ffffff", size: "12px" },
              }}
            />
          </AccumulationSeriesCollectionDirective>
        </AccumulationChartComponent>
      )}
    </div>
  );
};

export default SkillPopularityChart;
